const loadHeroVideo = () => {
  //load hero video on product pages
  let isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  let heroVideo = document.querySelector('#hero-bg-video source');
  if (heroVideo) {
    let mp4 = document.querySelector('#hero-bg-video');
    if (isMobile) {
      heroVideo.setAttribute('data-src', mp4.dataset.videoMobile);
    } else {
      heroVideo.setAttribute('data-src', mp4.dataset.video);
    }
  }
};

export { loadHeroVideo };
